import React, { useEffect, useState } from 'react';
//import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';
import { GetCluedoPista } from '../dao/GetCluedoPista';

const CluedoPage = () => {
    const [pista, setPista] = useState<any>(null);
    const [scanning, setScanning] = useState(true);
    const [error, setError] = useState("");

    /*useEffect(() => {
        let scanner: Html5QrcodeScanner | null = null;
        let timer: NodeJS.Timeout;

        if (scanning) {
            // Delay initialization slightly to prevent race conditions in Strict Mode
            timer = setTimeout(() => {
                const element = document.getElementById("reader");
                if (element) {
                    element.innerHTML = "";

                    scanner = new Html5QrcodeScanner(
                        "reader",
                        {
                            fps: 10,
                            qrbox: { width: 250, height: 250 },
                            supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
                        },
                        /false
                    );

                    scanner.render(async (decodedText) => {
                        console.log(`Code matched = ${decodedText}`);
                        if (scanner) {
                            try {
                                await scanner.clear();
                            } catch (e) {
                                console.error("Failed to clear scanner", e);
                            }
                        }

                        // VALIDATION: Must be QR followed by exactly 3 digits
                        const isValidCode = /^QR\d{3}$/.test(decodedText);

                        if (!isValidCode) {
                            setScanning(false);
                            if (decodedText.startsWith("CHAR")) {
                                setError("ERROR: Has escaneado un Personaje. Esta página es SOLO para EVIDENCIAS (CSI).");
                            } else {
                                setError("EVIDENCIA NO RECONOCIDA: Formato de código inválido.");
                            }
                            setPista(null);
                            return;
                        }

                        setScanning(false);
                        setError("");

                        const data = await GetCluedoPista(decodedText);
                        if (data) {
                            setPista(data);
                        } else {
                            setError("No se ha encontrado ninguna pista con este código en la base de datos.");
                        }
                    }, (errorMessage) => {
                        // parse error, ignore it.
                    });
                }
            }, 100);
        }

        return () => {
            clearTimeout(timer);
            if (scanner) {
                try {
                    scanner.clear();
                } catch (e) {
                    // ignore
                }
            }
        };
    }, [scanning]);
    */

    return (
        <div style={{
            backgroundColor: '#050505',
            color: '#00ff41',
            minHeight: '100vh',
            fontFamily: '"Courier New", Courier, monospace',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                borderBottom: '4px solid #00ff41',
                width: '100%',
                maxHeight: '15vh',
                textAlign: 'center',
                marginBottom: '20px',
                paddingBottom: '15px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <img
                    src="/images/beirao.png"
                    alt="Logo"
                    style={{
                        maxHeight: '80px',
                        marginBottom: '10px',
                        // Invert colors to make black become white, then tint it green to match theme
                        filter: 'invert(1) sepia(1) saturate(5) hue-rotate(90deg) brightness(1.2)'
                    }}
                />
                <h1 style={{ margin: 0, textShadow: '0 0 10px #00ff41', letterSpacing: '6px', fontSize: '2rem' }}>C.S.I. LANTERNS</h1>
                <small style={{ letterSpacing: '3px', fontSize: '1rem', fontWeight: 'bold' }}>UNIDAD DE ANÁLISIS FORENSE</small>
            </div>

            {scanning ? (
                <div style={{ width: '100%', maxWidth: '600px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div id="reader" style={{ border: '4px dashed #00ff41', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 0 20px rgba(0, 255, 65, 0.3)' }}></div>
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                        <p className="blink" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>BUSCANDO EVIDENCIA...</p>
                        <p style={{ fontSize: '1rem', color: '#00cc33' }}>Enfoque el código QR</p>
                    </div>
                </div>
            ) : (
                <div style={{ width: '100%', maxWidth: '700px', border: '2px solid #00ff41', padding: '25px', borderRadius: '8px', boxShadow: '0 0 25px rgba(0, 255, 65, 0.3)', backgroundColor: '#000000', marginBottom: '40px' }}>
                    {pista ? (
                        <>
                            <div style={{ borderBottom: '2px solid #00ff41', paddingBottom: '15px', marginBottom: '20px' }}>
                                <span style={{ background: '#00ff41', color: '#000', padding: '5px 10px', fontWeight: 'bold', fontSize: '1.2rem', borderRadius: '4px' }}>EVIDENCIA #{pista.id}</span>
                                <h1 style={{ margin: '15px 0 0 0', textTransform: 'uppercase', fontSize: '2rem', lineHeight: '1.2' }}>{pista.titol}</h1>
                            </div>

                            {pista.img && (
                                <div style={{ border: '2px solid #333', padding: '10px', marginBottom: '25px', position: 'relative', backgroundColor: '#111' }}>
                                    <div style={{ position: 'absolute', top: 10, left: 10, color: 'red', border: '3px solid red', padding: '5px 10px', fontSize: '1.2rem', transform: 'rotate(-5deg)', fontWeight: 'bold', zIndex: 10, background: 'rgba(0,0,0,0.7)' }}>CONFIDENCIAL</div>
                                    <img
                                        src={pista.img.startsWith('http') || pista.img.startsWith('data:') ? pista.img : `data:image/jpeg;base64,${pista.img}`}
                                        alt="Prueba"
                                        style={{ width: '100%', display: 'block', filter: 'grayscale(100%) contrast(1.2) brightness(1.1)' }}
                                    />
                                    {/* Scan lines overlay */}
                                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 255, 65, 0.15) 4px)', pointerEvents: 'none' }}></div>
                                </div>
                            )}

                            <div style={{ padding: '20px', borderLeft: '6px solid #00ff41', background: '#0f1f0f', marginTop: '20px' }}>
                                <p style={{ margin: 0, fontSize: '1.5rem', lineHeight: '1.5' }} dangerouslySetInnerHTML={{ __html: pista.descripcio }}></p>
                            </div>
                        </>
                    ) : (
                        <div style={{ color: '#ff3333', textAlign: 'center', border: '4px solid #ff3333', padding: '40px', backgroundColor: 'rgba(255, 50, 50, 0.1)' }}>
                            <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⚠️</div>
                            <h1 style={{ margin: 0, fontSize: '2.5rem' }}>ACCESO DENEGADO</h1>
                            <p style={{ margin: '20px 0 0 0', fontSize: '1.5rem' }}>{error}</p>
                        </div>
                    )}

                    <button
                        onClick={() => { setPista(null); setScanning(true); }}
                        style={{
                            marginTop: '40px',
                            background: '#000',
                            color: '#00ff41',
                            border: '2px solid #00ff41',
                            padding: '20px',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            display: 'block',
                            width: '100%',
                            fontFamily: 'inherit',
                            fontWeight: 'bold',
                            letterSpacing: '3px',
                            transition: 'all 0.2s',
                            boxShadow: '0 5px 15px rgba(0,0,0,0.5)',
                            textTransform: 'uppercase'
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.background = '#00ff41'; e.currentTarget.style.color = '#000'; }}
                        onMouseOut={(e) => { e.currentTarget.style.background = '#000'; e.currentTarget.style.color = '#00ff41'; }}
                        onTouchStart={(e) => { e.currentTarget.style.background = '#00ff41'; e.currentTarget.style.color = '#000'; }}
                        onTouchEnd={(e) => { e.currentTarget.style.background = '#000'; e.currentTarget.style.color = '#00ff41'; }}
                    >
                        NUEVO ESCANEO
                    </button>
                </div>
            )}
            <style>{`
                @keyframes blink { 50% { opacity: 0; } }
                .blink { animation: blink 1s linear infinite; }
            `}</style>
        </div>
    );
};

export default CluedoPage;
